import { CoreDataSecurityMonitorsAllName } from './name';
import { createRemoveCollectionSyncSlice } from '@sonar-software/xuder';
import { DeleteDataSecurityMonitorByIdRequest } from '@api/data-security';
import { getCoreDataSecurityMonitorsAllSlice } from './get';

export const removeCoreDataSecurityMonitorsAllSyncSlice = createRemoveCollectionSyncSlice({
	hasRequest: true,
	name: CoreDataSecurityMonitorsAllName,
	state: getCoreDataSecurityMonitorsAllSlice.asyncState,
	target: (request: DeleteDataSecurityMonitorByIdRequest) => (monitor) => monitor.id === request.monitorId
});
